<app-header></app-header>
<section class="content-box">
  <div class="tab-content" id="myTabContent">
    <!--  market Position -->
    <div class="tab-pane fade show active" id="market">
      <div class="deta-tebal-box">
        <div class="heading-border-box">
          <!-- <p *ngIf="badlaOrderList[1]">{{badlaOrderList[1]['badlaDetail'][0]['reference']}} [{{badlaOrderList[1]['badlaDetail'][0]['duty']}}]   
                        <ng-container *ngIf="resultPl">
                             - Total PL :
                            <span [ngClass]="resultPl['CalculateBalance'] > 0 ? 'buy-class' : 'sell-class'">{{(resultPl) ? resultPl['CalculateBalance'] : ''}}</span>
                        </ng-container>
                    </p> -->
          <span>
            <a
              class="btn btn-danger p-0 px-3 m-1"
              [routerLink]="['/endbadlaorder']"
            >
              <i class="fas fa-arrow-left"></i> Back
            </a>
            <a class="btn btn-success p-0 px-3 m-1" (click)="downloadAsPDF()">
              <i class="fas fa-download"></i> PDF
            </a>
            <!-- <a class="btn btn-info p-0 px-3 m-0" (click)="downloadAsExcel()">
              <i class="fas fa-file-excel"></i> Excel
            </a> -->
          </span>
          <span>
            {{ badlaTitle ? badlaTitle : "" }}
          </span>
        </div>

        <div class="respo-scroll">
          <!-- <table class="default-table-style m-1" *ngFor="let badlaOrder of badlaOrderList; let i = index; let last = last;"> -->
          <table class="default-table-style m-1" id="htmlData">
            <thead>
              <tr>
                <th class="text-left col-md-3">Date</th>
                <!-- <th class="text-left col-md-3">Type</th> -->
                <th class="text-left col-md-3">Particular</th>
                <th class="text-right col-md-3">Amount</th>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngFor="
                  let badlaOrder of badlaOrderList;
                  let i = index;
                  let last = last
                "
              >
                <tr *ngIf="badlaOrder['type'] == 'opening'">
                  <td class="text-left col-md-3">
                    {{ badlaOrder["createdAt"] | date: "dd/MM/yyyy h:mm a" }}
                  </td>
                  <!-- <td class="text-left col-md-3">Opening</td> -->
                  <td class="text-left col-md-3">opening</td>
                  <td class="text-right col-md-3">
                    <span
                      [ngClass]="
                        badlaOrder['transactionType'] == 'credit'
                          ? 'buy-class'
                          : 'sell-class'
                      "
                      >{{
                        badlaOrder["transactionType"] == "credit"
                          ? badlaOrder["amount"]
                          : badlaOrder["amount"] * -1
                      }}</span
                    >
                  </td>
                </tr>
                <tr *ngIf="badlaOrder['type'] == 'brokerage'">
                  <td class="text-left col-md-3">
                    {{ badlaOrder["createdAt"] | date: "dd/MM/yyyy h:mm a" }}
                    <br />
                    Brokerage <br />
                  </td>

                  <td class="text-left m-0 p-0">
                    <table class="w-100">
                      <tbody>
                        <tr>
                          <td>
                            Comex -
                            {{
                              badlaOrder["badlaDetail"]["length"] > 0
                                ? badlaOrder["badlaDetail"][0]["name"]
                                : ""
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"]["length"] > 0
                                ? badlaOrder["badlaDetail"][0]["expiry"]
                                : ""
                            }}
                          </td>
                          <td>
                            <span class="sell-class">{{
                              badlaOrder["comexbro"]
                            }}</span>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            Mcx -
                            {{
                              badlaOrder["badlaDetail"]["length"] > 0
                                ? badlaOrder["badlaDetail"][1]["name"]
                                : ""
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"]["length"] > 0
                                ? badlaOrder["badlaDetail"][1]["expiry"]
                                : ""
                            }}
                          </td>
                          <td>
                            <span class="sell-class">{{
                              badlaOrder["mcxbro"]
                            }}</span>
                          </td>
                        </tr>

                        <tr>
                          <td>
                            Dgcx -
                            {{
                              badlaOrder["badlaDetail"]["length"] > 0
                                ? badlaOrder["badlaDetail"][2]["name"]
                                : ""
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"]["length"] > 0
                                ? badlaOrder["badlaDetail"][2]["expiry"]
                                : ""
                            }}
                          </td>
                          <td>
                            <span class="sell-class">{{
                              badlaOrder["dgcxbro"]
                            }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>

                  <td class="text-right col-md-3">
                    <span
                      [ngClass]="
                        badlaOrder['transactionType'] == 'credit'
                          ? 'buy-class'
                          : 'sell-class'
                      "
                      >{{
                        badlaOrder["transactionType"] == "credit"
                          ? badlaOrder["amount"]
                          : badlaOrder["amount"] * -1
                      }}</span
                    >
                  </td>
                </tr>
                <tr *ngIf="badlaOrder['type'] == 'pl'">
                  <td class="text-left col-md-3">
                    {{ badlaOrder["createdAt"] | date: "dd/MM/yyyy h:mm a" }}
                    <button
                      type="button"
                      class="btn btn-outline-info btn-sm m-1"
                      (click)="
                        editBadlaModal(
                          badlaOrder['badlaDetail'][0]['_id'],
                          badlaOrder['_id'],
                          last
                        )
                      "
                    >
                      <i class="fas fa-edit"></i>
                    </button>
                    <ng-container *ngIf="totalPlCnt == badlaOrder['sno']">
                      <button
                        type="button"
                        class="btn btn-outline-danger btn-sm m-1"
                        (click)="
                          deleteBadlaModal(
                            badlaOrder['badlaDetail'][0]['_id'],
                            badlaOrder['_id']
                          )
                        "
                      >
                        <i class="fas fa-trash"></i>
                      </button>
                    </ng-container>
                    <br />
                    Weekly Settlement <br />
                    Order badla :
                    <span
                      [ngClass]="
                        badlaOrder['badlaDetail'][0]['rateBadla'] == 'buy'
                          ? 'buy-class'
                          : 'sell-class'
                      "
                      >{{ badlaOrder["badlaDetail"][0]["rateBadla"] }}</span
                    ><br />
                    Weekly Settlement badla :
                    <span
                      [ngClass]="
                        badlaOrder['badlaDetail'][0]['weeklySettleBadla'] ==
                        'buy'
                          ? 'buy-class'
                          : 'sell-class'
                      "
                      >{{
                        badlaOrder["badlaDetail"][0]["weeklySettleBadla"]
                      }}</span
                    >
                    <br />
                    Clearing Rate :
                    {{
                      badlaOrder["badlaDetail"][0]["dollerClearingRate"]
                        | number: "1.2-2"
                    }}
                  </td>

                  <td class="text-left m-0 p-0">
                    <table class="w-100">
                      <tbody>
                        <tr>
                          <td>
                            {{
                              badlaOrder["badlaDetail"][0]["comexDetail"][0][
                                "original_exchange"
                              ]
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"][0]["comexDetail"][0][
                                "name"
                              ]
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"][0]["comexDetail"][0][
                                "expiry"
                              ]
                            }}
                          </td>
                          <td class="text-center">
                            <span
                              [ngClass]="
                                badlaOrder['badlaDetail'][0]['comexType'] ==
                                'buy'
                                  ? 'buy-class'
                                  : 'sell-class'
                              "
                              >{{
                                badlaOrder["badlaDetail"][0]["comexType"]
                                  | titlecase
                              }}</span
                            >
                            - {{ badlaOrder["badlaDetail"][0]["comexQty"] }} -
                            {{ badlaOrder["badlaDetail"][0]["comexPrice"] }}
                          </td>
                          <td class="text-center">
                            <span
                              [ngClass]="
                                badlaOrder['badlaDetail'][0]['endComexType'] ==
                                'buy'
                                  ? 'buy-class'
                                  : 'sell-class'
                              "
                              >{{
                                badlaOrder["badlaDetail"][0]["endComexType"]
                                  | titlecase
                              }}</span
                            >
                            -
                            {{
                              badlaOrder["partialOrderSell"] &&
                              badlaOrder["partialOrderSell"] == true
                                ? badlaOrder["badlaDetail"][0]["endComexQty"]
                                : badlaOrder["badlaDetail"][0]["comexQty"]
                            }}
                            -
                            {{ badlaOrder["badlaDetail"][0]["endComexPrice"] }}
                          </td>
                          <td class="text-right">
                            <span
                              [ngClass]="
                                badlaOrder['badlaDetail'][0]['comexResult'] > 0
                                  ? 'buy-class'
                                  : ' sell-class'
                              "
                            >
                              {{
                                badlaOrder["badlaDetail"][0]["comexResult"]
                              }}</span
                            >
                          </td>
                        </tr>

                        <tr>
                          <td>
                            {{
                              badlaOrder["badlaDetail"][0]["mcxDetail"][0][
                                "original_exchange"
                              ]
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"][0]["mcxDetail"][0][
                                "name"
                              ]
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"][0]["mcxDetail"][0][
                                "expiry"
                              ]
                            }}
                          </td>
                          <td class="text-center">
                            <span
                              [ngClass]="
                                badlaOrder['badlaDetail'][0]['mcxType'] == 'buy'
                                  ? 'buy-class'
                                  : 'sell-class'
                              "
                              >{{
                                badlaOrder["badlaDetail"][0]["mcxType"]
                                  | titlecase
                              }}</span
                            >
                            - {{ badlaOrder["badlaDetail"][0]["mcxQty"] }} -
                            {{ badlaOrder["badlaDetail"][0]["mcxPrice"] }}
                          </td>
                          <td class="text-center">
                            <span
                              [ngClass]="
                                badlaOrder['badlaDetail'][0]['endMcxType'] ==
                                'buy'
                                  ? 'buy-class'
                                  : 'sell-class'
                              "
                              >{{
                                badlaOrder["badlaDetail"][0]["endMcxType"]
                                  | titlecase
                              }}
                            </span>
                            - {{ badlaOrder["badlaDetail"][0]["mcxQty"] }} -
                            {{ badlaOrder["badlaDetail"][0]["endMcxPrice"] }}
                          </td>
                          <td class="text-right">
                            <span
                              [ngClass]="
                                badlaOrder['badlaDetail'][0]['mcxResult'] > 0
                                  ? 'buy-class'
                                  : 'sell-class'
                              "
                            >
                              {{
                                badlaOrder["badlaDetail"][0]["mcxResult"]
                              }}</span
                            >
                          </td>
                        </tr>

                        <tr>
                          <td>
                            {{
                              badlaOrder["badlaDetail"][0]["dgcxDetail"][0][
                                "original_exchange"
                              ]
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"][0]["dgcxDetail"][0][
                                "name"
                              ]
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"][0]["dgcxDetail"][0][
                                "expiry"
                              ]
                            }}
                          </td>
                          <td class="text-center">
                            <span
                              [ngClass]="
                                badlaOrder['badlaDetail'][0]['dgcxType'] ==
                                'buy'
                                  ? 'buy-class'
                                  : 'sell-class'
                              "
                              >{{
                                badlaOrder["badlaDetail"][0]["dgcxType"]
                                  | titlecase
                              }}</span
                            >
                            - {{ badlaOrder["badlaDetail"][0]["dgcxQty"] }} -
                            {{ badlaOrder["badlaDetail"][0]["dgcxPrice"] }}
                          </td>
                          <td class="text-center">
                            <span
                              [ngClass]="
                                badlaOrder['badlaDetail'][0]['endDgcxType'] ==
                                'buy'
                                  ? 'buy-class'
                                  : 'sell-class'
                              "
                              >{{
                                badlaOrder["badlaDetail"][0]["endDgcxType"]
                                  | titlecase
                              }}</span
                            >
                            - {{ badlaOrder["badlaDetail"][0]["dgcxQty"] }} -
                            {{ badlaOrder["badlaDetail"][0]["endDgcxPrice"] }}
                          </td>
                          <td class="text-right">
                            <span
                              [ngClass]="
                                badlaOrder['badlaDetail'][0]['dgcxResult'] > 0
                                  ? 'buy-class'
                                  : 'sell-class'
                              "
                            >
                              {{
                                badlaOrder["badlaDetail"][0]["dgcxResult"]
                              }}</span
                            >
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>

                  <td class="text-right col-md-3">
                    <span
                      [ngClass]="
                        badlaOrder['transactionType'] == 'credit'
                          ? 'buy-class'
                          : 'sell-class'
                      "
                      >{{
                        badlaOrder["transactionType"] == "credit"
                          ? badlaOrder["amount"]
                          : badlaOrder["amount"] * -1
                      }}</span
                    >
                  </td>
                </tr>
                <tr *ngIf="badlaOrder['type'] == 'partialOrder'">
                  <td class="text-left col-md-3">
                    {{ badlaOrder["createdAt"] | date: "dd/MM/yyyy h:mm a" }}
                    <ng-container *ngIf="totalPlCnt == badlaOrder['sno']">
                      <button
                        type="button"
                        class="btn btn-outline-danger btn-sm m-1"
                        (click)="
                          deleteBadlaModal(
                            badlaOrder['badlaDetail'][0]['_id'],
                            badlaOrder['_id']
                          )
                        "
                      >
                        <i class="fas fa-trash"></i>
                      </button>
                    </ng-container>
                    <br />
                    <span class="buy-class">Add Order</span>
                    <br />
                    Order badla :
                    <span
                      [ngClass]="
                        badlaOrder['badlaDetail'][0]['rateBadla'] == 'buy'
                          ? 'buy-class'
                          : 'sell-class'
                      "
                      >{{ badlaOrder["badlaDetail"][0]["rateBadla"] }}</span
                    ><br />
                  </td>

                  <td class="text-left m-0 p-0">
                    <table class="w-100">
                      <tbody>
                        <tr>
                          <td>
                            {{
                              badlaOrder["badlaDetail"][0]["comexDetail"][0][
                                "original_exchange"
                              ]
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"][0]["comexDetail"][0][
                                "name"
                              ]
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"][0]["comexDetail"][0][
                                "expiry"
                              ]
                            }}
                          </td>
                          <td class="text-center">
                            <span
                              [ngClass]="
                                badlaOrder['badlaDetail'][0]['comexType'] ==
                                'buy'
                                  ? 'buy-class'
                                  : 'sell-class'
                              "
                              >{{
                                badlaOrder["badlaDetail"][0]["comexType"]
                                  | titlecase
                              }}</span
                            >
                            - {{ badlaOrder["badlaDetail"][0]["comexQtyEx"] }} -
                            {{ badlaOrder["badlaDetail"][0]["comexPriceEx"] }}
                          </td>
                        </tr>

                        <tr>
                          <td>
                            {{
                              badlaOrder["badlaDetail"][0]["mcxDetail"][0][
                                "original_exchange"
                              ]
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"][0]["mcxDetail"][0][
                                "name"
                              ]
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"][0]["mcxDetail"][0][
                                "expiry"
                              ]
                            }}
                          </td>
                          <td class="text-center">
                            <span
                              [ngClass]="
                                badlaOrder['badlaDetail'][0]['mcxType'] == 'buy'
                                  ? 'buy-class'
                                  : 'sell-class'
                              "
                              >{{
                                badlaOrder["badlaDetail"][0]["mcxType"]
                                  | titlecase
                              }}</span
                            >
                            - {{ badlaOrder["badlaDetail"][0]["mcxQtyEx"] }} -
                            {{ badlaOrder["badlaDetail"][0]["mcxPriceEx"] }}
                          </td>
                        </tr>

                        <tr>
                          <td>
                            {{
                              badlaOrder["badlaDetail"][0]["dgcxDetail"][0][
                                "original_exchange"
                              ]
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"][0]["dgcxDetail"][0][
                                "name"
                              ]
                            }}
                            -
                            {{
                              badlaOrder["badlaDetail"][0]["dgcxDetail"][0][
                                "expiry"
                              ]
                            }}
                          </td>
                          <td class="text-center">
                            <span
                              [ngClass]="
                                badlaOrder['badlaDetail'][0]['dgcxType'] ==
                                'buy'
                                  ? 'buy-class'
                                  : 'sell-class'
                              "
                              >{{
                                badlaOrder["badlaDetail"][0]["dgcxType"]
                                  | titlecase
                              }}</span
                            >
                            - {{ badlaOrder["badlaDetail"][0]["dgcxQtyEx"] }} -
                            {{ badlaOrder["badlaDetail"][0]["dgcxPriceEx"] }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>

                  <td class="text-right col-md-3">
                    <span
                      [ngClass]="
                        badlaOrder['transactionType'] == 'credit'
                          ? 'buy-class'
                          : 'sell-class'
                      "
                      >{{
                        badlaOrder["transactionType"] == "credit"
                          ? badlaOrder["amount"]
                          : badlaOrder["amount"] * -1
                      }}</span
                    >
                  </td>
                </tr>
              </ng-container>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="2" class="text-right">Total:</td>
                <td class="text-right">
                  <ng-container *ngIf="resultPl">
                    <span
                      [ngClass]="
                        resultPl['CalculateBalance'] > 0
                          ? 'buy-class'
                          : 'sell-class'
                      "
                      >{{ resultPl ? resultPl["CalculateBalance"] : "" }}</span
                    >
                  </ng-container>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
    <!-- badle settig -->
    <div class="tab-pane fade" id="badle">1</div>
    <!--  settig Report -->
    <div class="tab-pane fade" id="settig">2</div>
    <!-- porfile Summary -->
    <div class="tab-pane fade" id="porfile">3</div>
  </div>
</section>

<app-footer></app-footer>

<!-- Modal -->
<div
  class="modal fade"
  bsModal
  #orderModal="bs-modal"
  [config]="{}"
  id="exampleModalCenter"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title" id="exampleModalLongTitle">
          <span *ngIf="!filter.id && endOrder == false">Add badla order</span>
          <span *ngIf="filter.id && endOrder == false">Update badla order</span>
          <span *ngIf="endOrder == true">Edit End badla order</span>
        </h6>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeModal()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0 m-2">
        <form
          #addBadlaOrder="ngForm"
          (ngSubmit)="addBadlaOrder.form.valid && createBadlaOrder()"
        >
          <div class="form-group row">
            <div class="col-lg-4 col-sm-6 col-6 input-box-grup">
              <label for="inputPassword" class="col-form-label"
                >Reference Name</label
              >
              <input
                type="text"
                class="form-control"
                placeholder="Reference Name"
                [(ngModel)]="filter.reference"
                name="referenceName"
                #referenceName="ngModel"
                required
                pattern="^[A-Za-z0-9._ -]*$"
                maxlength="50"
                [disabled]="endOrder == true"
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="referenceName.errors?.required"
                  class="invalid-error"
                >
                  Enter Reference.
                </div>
                <div
                  *ngIf="referenceName.errors?.pattern"
                  class="invalid-error"
                >
                  Enter Valid Reference.
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-sm-3 col-6 input-box-grup main-chek">
              <div class="form-check" *ngIf="endOrder == false">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                  [(ngModel)]="isBrokrageCheck"
                  name="brokrageCheckBox"
                  #brokrageCheckBox="ngModel"
                  (change)="checkBrokrage(isBrokrageCheck ? true : false)"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Add Brokerage
                </label>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div class="col-lg-4 col-sm-6 col-6 input-box-grup">
              <label for="inputPassword" class="col-form-label"
                >Badla Instrument</label
              >
              <select
                class="form-control"
                [(ngModel)]="filter.type"
                name="badlaType"
                #badlaType="ngModel"
                required
                [disabled]="endOrder == true"
                (change)="badlaScriptChnage($event.target.value)"
              >
                <option [ngValue]="null">Select Badla</option>
                <option
                  *ngFor="let title of badlaInstrument"
                  [value]="title._id"
                >
                  {{ title.settingName }}
                </option>
              </select>
              <div *ngIf="addBadlaOrder.submitted">
                <div *ngIf="badlaType.errors?.required" class="invalid-error">
                  Please Select Badla Type.
                </div>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 col-6 input-box-grup">
              <label for="inputPassword" class="col-sm-2 col-form-label"
                >Duty</label
              >
              <input
                type="text"
                class="form-control"
                placeholder="Duty"
                [(ngModel)]="filter.duty"
                name="dutyName"
                #dutyName="ngModel"
                required
                pattern="^[0-9._-]*$"
                maxlength="10"
                [disabled]="endOrder == true"
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div *ngIf="dutyName.errors?.required" class="invalid-error">
                  Enter Duty.
                </div>
                <div *ngIf="dutyName.errors?.pattern" class="invalid-error">
                  Enter Valid Duty.
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-sm-6 col-6 input-box-grup">
              <label for="inputPassword">Opening Amount(Optional)</label>
              <input
                type="text"
                class="form-control"
                placeholder="Opening Amount"
                [(ngModel)]="filter.openingAmount"
                name="openingAmount"
                #openingAmount="ngModel"
                pattern="^[0-9._-]*$"
                maxlength="10"
                [disabled]="endOrder == true"
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="openingAmount.errors?.pattern"
                  class="invalid-error"
                >
                  Enter Valid Opening Amount.
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
            >
              <label for="inputPassword" class="col-form-label"
                >COMEX Instrument</label
              >
              <select
                class="form-control"
                [(ngModel)]="filter.comexbadlaInst"
                name="comexInstName"
                #comexInstName="ngModel"
                (change)="chnageInsrument($event.target.value, 'comexRateId')"
                required
                [disabled]="endOrder == true"
              >
                <option [ngValue]="null">Select Instrument</option>
                <option
                  *ngFor="let badla of comexBadlaInstrument"
                  [value]="badla.instrument_token"
                >
                  {{ badla.exchange }} - {{ badla.name }} - {{ badla.expiry }}
                </option>
              </select>
              <div id="comexRateId"></div>
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="comexInstName.errors?.required"
                  class="invalid-error"
                >
                  Please Select COMEX Instrument.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
            >
              <label for="Type" class="col-form-label">Type</label>
              <select
                class="form-control"
                [(ngModel)]="filter.comexType"
                name="comexTypeName"
                #comexTypeName="ngModel"
                required
                (change)="comexTypeChnage()"
                [disabled]="endOrder == true"
              >
                <option [ngValue]="null">Type</option>
                <option value="buy">Buy</option>
                <option value="sell">Sell</option>
              </select>
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="comexTypeName.errors?.required"
                  class="invalid-error"
                >
                  Please Select Type.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
            >
              <label for="Qty" class="col-form-label">Qty</label>
              <input
                type="text"
                class="form-control"
                placeholder="Qty"
                [(ngModel)]="filter.comexQty"
                name="comexQtyeName"
                #comexQtyeName="ngModel"
                required
                pattern="^[0-9._-]*$"
                maxlength="5"
                [disabled]="endOrder == true"
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="comexQtyeName.errors?.required"
                  class="invalid-error"
                >
                  Enter Qty.
                </div>
                <div
                  *ngIf="comexQtyeName.errors?.pattern"
                  class="invalid-error"
                >
                  Enter Valid Qty.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
            >
              <label for="Price" class="col-form-label">Price</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="filter.comexPrice"
                placeholder="Price"
                name="comexPriceName"
                #comexPriceName="ngModel"
                required
                pattern="^[0-9.]*$"
                maxlength="10"
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="comexPriceName.errors?.required"
                  class="invalid-error"
                >
                  Enter Price.
                </div>
                <div
                  *ngIf="comexPriceName.errors?.pattern"
                  class="invalid-error"
                >
                  Enter Valid Price.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
              *ngIf="isBrokrageCheck"
            >
              <label for="Type" class="col-form-label">Type</label>
              <select
                class="form-control"
                [(ngModel)]="filter.comexBroType"
                name="comexBrokrageType"
                #comexBrokrageType="ngModel"
                required
                [disabled]="endOrder == true"
              >
                <option [ngValue]="null">Brokrage Type</option>
                <option value="lot">Lotwise</option>
                <!-- <option value="sell">Percentage</option> -->
              </select>
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="comexBrokrageType.errors?.required"
                  class="invalid-error"
                >
                  Please Select Type.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
              *ngIf="isBrokrageCheck"
            >
              <label for="Brokerage Amount" class="col-form-label"
                >Brokerage Amount</label
              >
              <input
                type="text"
                class="form-control"
                placeholder="Brokerage Amount"
                [(ngModel)]="filter.comexBroAmount"
                name="comexBrokrageAmount"
                #comexBrokrageAmount="ngModel"
                required
                pattern="^[0-9._-]*$"
                maxlength="5"
                [disabled]="endOrder == true"
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="comexBrokrageAmount.errors?.required"
                  class="invalid-error"
                >
                  Enter Amount.
                </div>
                <div
                  *ngIf="comexBrokrageAmount.errors?.pattern"
                  class="invalid-error"
                >
                  Enter Valid Amount.
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
            >
              <label for="MCX Instrument" class="col-form-label"
                >MCX Instrument</label
              >
              <select
                class="form-control"
                [(ngModel)]="filter.mcxbadlaInst"
                name="mcxInstName"
                (change)="chnageInsrument($event.target.value, 'mcxRateId')"
                #mcxInstName="ngModel"
                required
                [disabled]="endOrder == true"
              >
                <option [ngValue]="null">Select Instrument</option>
                <option
                  *ngFor="let badla of mcxBadlaInstrument"
                  [value]="badla.instrument_token"
                >
                  {{ badla.exchange }} - {{ badla.name }} - {{ badla.expiry }}
                </option>
              </select>
              <div id="mcxRateId"></div>
              <div *ngIf="addBadlaOrder.submitted">
                <div *ngIf="mcxInstName.errors?.required" class="invalid-error">
                  Please Select MCX Instrument.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
            >
              <label for="Type" class="col-form-label">Type</label>
              <select
                class="form-control"
                [(ngModel)]="filter.mcxType"
                name="mcxTypeName"
                #mcxTypeName="ngModel"
                required
                disabled="true"
              >
                <option [ngValue]="null">Type</option>
                <option value="buy">Buy</option>
                <option value="sell">Sell</option>
              </select>
              <div *ngIf="addBadlaOrder.submitted">
                <div *ngIf="mcxTypeName.errors?.required" class="invalid-error">
                  Please Select Type.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
            >
              <label for="Qty" class="col-form-label">Qty</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="filter.mcxQty"
                placeholder="Qty"
                name="mcxQtyeName"
                #mcxQtyeName="ngModel"
                required
                pattern="^[0-9.]*$"
                [disabled]="endOrder == true"
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div *ngIf="mcxQtyeName.errors?.required" class="invalid-error">
                  Enter Qty.
                </div>
                <div *ngIf="mcxQtyeName.errors?.pattern" class="invalid-error">
                  Enter Valid Qty.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
            >
              <label for="Price" class="col-form-label">Price</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="filter.mcxPrice"
                placeholder="Price"
                name="mcxPriceName"
                #mcxPriceName="ngModel"
                pattern="^[0-9_.-]*$"
                required
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="mcxPriceName.errors?.required"
                  class="invalid-error"
                >
                  Enter Price.
                </div>
                <div *ngIf="mcxPriceName.errors?.pattern" class="invalid-error">
                  Enter Valid Qty.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
              *ngIf="isBrokrageCheck"
            >
              <label for="Type" class="col-form-label">Type</label>
              <select
                class="form-control"
                [(ngModel)]="filter.mcxBroType"
                name="mcxBrokrageType"
                #mcxBrokrageType="ngModel"
                required
                [disabled]="endOrder == true"
              >
                <option [ngValue]="null">Brokrage Type</option>
                <option value="lot">Lotwise</option>
                <option value="per">Turnoverwise % | Lakh</option>
              </select>
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="mcxBrokrageType.errors?.required"
                  class="invalid-error"
                >
                  Please Select Type.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
              *ngIf="isBrokrageCheck"
            >
              <label for="Brokerage Amount" class="col-form-label"
                >Brokerage Amount</label
              >
              <input
                type="text"
                class="form-control"
                placeholder="Brokerage Amount"
                [(ngModel)]="filter.mcxBroAmount"
                name="mcxBrokrageAmount"
                #mcxBrokrageAmount="ngModel"
                required
                pattern="^[0-9._-]*$"
                maxlength="5"
                [disabled]="endOrder == true"
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="mcxBrokrageAmount.errors?.required"
                  class="invalid-error"
                >
                  Enter Amount.
                </div>
                <div
                  *ngIf="mcxBrokrageAmount.errors?.pattern"
                  class="invalid-error"
                >
                  Enter Valid Amount.
                </div>
              </div>
            </div>
          </div>
          <div class="form-group row">
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
            >
              <label for="inputPassword" class="col-form-label"
                >DGCX Instrument</label
              >
              <select
                class="form-control"
                [(ngModel)]="filter.dgcxbadlaInst"
                name="dgcxInstName"
                (change)="chnageInsrument($event.target.value, 'dgcxRateId')"
                #dgcxInstName="ngModel"
                required
                [disabled]="endOrder == true"
              >
                <option [ngValue]="null">Select Instrument</option>
                <option
                  *ngFor="let badla of dgcxBadlaInstrument"
                  [value]="badla.instrument_token"
                >
                  {{ badla.exchange }} - {{ badla.name }} - {{ badla.expiry }}
                </option>
              </select>
              <div id="dgcxRateId"></div>
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="dgcxInstName.errors?.required"
                  class="invalid-error"
                >
                  Please Select DGCX Instrument.
                </div>
              </div>
            </div>

            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
            >
              <label for="Type" class="col-form-label">Type</label>
              <select
                class="form-control"
                [(ngModel)]="filter.dgcxType"
                name="dgcxTypeName"
                #dgcxTypeName="ngModel"
                required
                disabled="true"
              >
                <option [ngValue]="null">Type</option>
                <option value="buy">Buy</option>
                <option value="sell">Sell</option>
              </select>
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="dgcxTypeName.errors?.required"
                  class="invalid-error"
                >
                  Please Select Type.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
            >
              <label for="Qty" class="col-form-label">Qty</label>
              <input
                type="text"
                class="form-control"
                placeholder="Qty"
                [(ngModel)]="filter.dgcxQty"
                name="dgcxQtyeName"
                #dgcxQtyeName="ngModel"
                required
                pattern="^[0-9.]*$"
                [disabled]="endOrder == true"
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="dgcxQtyeName.errors?.required"
                  class="invalid-error"
                >
                  Enter Qty.
                </div>
                <div *ngIf="dgcxQtyeName.errors?.pattern" class="invalid-error">
                  Enter Valid Qty.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
            >
              <label for="Price" class="col-form-label">Price</label>
              <input
                type="text"
                class="form-control"
                [(ngModel)]="filter.dgcxPrice"
                placeholder="Price"
                name="dgcxPriceName"
                #dgcxPriceName="ngModel"
                required
                pattern="^[0-9_.-]*$"
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="dgcxPriceName.errors?.required"
                  class="invalid-error"
                >
                  Enter Price.
                </div>
                <div
                  *ngIf="dgcxPriceName.errors?.pattern"
                  class="invalid-error"
                >
                  Enter Valid Price.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
              *ngIf="isBrokrageCheck"
            >
              <label for="inputPassword" class="col-form-label">Type</label>
              <select
                class="form-control"
                [(ngModel)]="filter.dgcxBroType"
                name="dgcxBrokrageType"
                #dgcxBrokrageType="ngModel"
                required
                [disabled]="endOrder == true"
              >
                <option [ngValue]="null">Brokrage Type</option>
                <option value="lot">Lotwise</option>
                <!-- <option value="sell">Percentage</option> -->
              </select>
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="dgcxBrokrageType.errors?.required"
                  class="invalid-error"
                >
                  Please Select Type.
                </div>
              </div>
            </div>
            <div
              class="{{
                isBrokrageCheck == true
                  ? 'col-lg-2 col-sm-6 col-6 input-box-grup'
                  : 'col-lg-3 col-sm-6 col-6 input-box-grup'
              }}"
              *ngIf="isBrokrageCheck"
            >
              <label for="Brokerage Amount" class="col-form-label"
                >Brokerage Amount</label
              >
              <input
                type="text"
                class="form-control"
                placeholder="Brokerage Amount"
                [(ngModel)]="filter.dgcxBroAmount"
                name="dgcxBrokrageAmount"
                #dgcxBrokrageAmount="ngModel"
                required
                pattern="^[0-9._-]*$"
                maxlength="5"
                [disabled]="endOrder == true"
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="dgcxBrokrageAmount.errors?.required"
                  class="invalid-error"
                >
                  Enter Amount.
                </div>
                <div
                  *ngIf="dgcxBrokrageAmount.errors?.pattern"
                  class="invalid-error"
                >
                  Enter Valid Amount.
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row" *ngIf="endOrder == true">
            <!-- <div class="col-lg-3 col-sm-6 col-6">
                            <input name="options" ng-control="options" type="radio" [value]="1" [(ngModel)]="filter.endandopen"> End Badla<br/>
                        </div>
                        <div class="col-lg-3 col-sm-6 col-6">
                            <input name="options" ng-control="options" type="radio" [value]="2" [(ngModel)]="filter.endandopen"> End Badla & Open<br/>
                        </div> -->
            <div class="col-lg-3 col-sm-6 col-6 input-box-grup">
              <label for="Brokerage Amount" class="col-form-label"
                >Select End Badla Option</label
              >
              <select
                class="form-control"
                [(ngModel)]="filter.endandopen"
                name="endBadlaType"
                #endBadlaType="ngModel"
                required
                (change)="settlementTypeChnage($event.target.value)"
              >
                <option [ngValue]="null">Type</option>
                <option value="1" *ngIf="isLast">End Badla</option>
                <option value="2">Weekly Settlement</option>
                <option value="3">Weekly Settlement With Clearing Rate</option>
              </select>
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="endBadlaType.errors?.required"
                  class="invalid-error"
                >
                  Enter Badla Type.
                </div>
              </div>
            </div>
            <div
              class="col-lg-2 col-sm-3 col-6 input-box-grup main-chek"
              *ngIf="endOrder == true && filter.endandopen == '1'"
            >
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  value=""
                  id="flexCheckDefault"
                  [(ngModel)]="isEndClosingRate"
                  name="closdingCheckBox"
                  #closdingCheckBox="ngModel"
                  (change)="checkEndClosing(isEndClosingRate ? true : false)"
                />
                <label class="form-check-label" for="flexCheckDefault">
                  Add Closing Rate
                </label>
              </div>
            </div>
            <div
              class="col-lg-3 col-sm-6 col-6 input-box-grup"
              *ngIf="
                endOrder == true &&
                filter.endandopen == '1' &&
                isEndClosingRate == true
              "
            >
              <label for="Brokerage Amount" class="col-form-label"
                >Doller Closing Rate</label
              >
              <input
                type="text"
                class="form-control"
                [(ngModel)]="closingRate"
                placeholder="Doller Closing"
                name="closingRateAmt"
                #closingRateAmt="ngModel"
                required
                pattern="^[0-9_.-]*$"
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="closingRateAmt.errors?.required"
                  class="invalid-error"
                >
                  Enter Doller Closing.
                </div>
              </div>
            </div>

            <div
              class="col-lg-3 col-sm-6 col-6 input-box-grup"
              *ngIf="endOrder == true && settlementType == '3'"
            >
              <label for="Brokerage Amount" class="col-form-label"
                >Doller Closing Rate</label
              >
              <input
                type="text"
                class="form-control"
                [(ngModel)]="closingRate"
                placeholder="Doller Closing"
                name="closingRateAmt"
                #closingRateAmt="ngModel"
                required
                pattern="^[0-9_.-]*$"
              />
              <div *ngIf="addBadlaOrder.submitted">
                <div
                  *ngIf="closingRateAmt.errors?.required"
                  class="invalid-error"
                >
                  Enter Doller Closing.
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-2">
            <div class="col-6 m-0">
              <button
                type="button"
                class="btn btn-danger w-100"
                data-dismiss="modal"
                (click)="closeModal()"
              >
                Close
              </button>
            </div>

            <div class="col-6 m-0" *ngIf="!filter.id && endOrder == false">
              <button type="submit" class="btn btn-success w-100">
                Submit
              </button>
            </div>
            <div class="col-6 m-0" *ngIf="filter.id && endOrder == false">
              <button type="submit" class="btn btn-success w-100">
                Update
              </button>
            </div>
            <div class="col-6 m-0" *ngIf="endOrder == true">
              <button type="submit" class="btn btn-success w-100">
                Submit
              </button>
            </div>
          </div>
          <!--  -->
        </form>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  bsModal
  #deleteModal="bs-modal"
  [config]="{}"
  id="exampleModalCenter"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title" id="exampleModalLongTitle">
          <span>Delete badla order</span>
        </h6>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeDeleteBadlaOrder()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <p>Are you sure you want to delete?</p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          (click)="closeDeleteBadlaOrder()"
        >
          Close
        </button>
        <button
          type="button"
          class="btn btn-success"
          (click)="deleteBadlaOrder()"
        >
          Confirm
        </button>
      </div>
    </div>
  </div>
</div>
